import { render, staticRenderFns } from "./ComponentsTab.vue?vue&type=template&id=c83cb10e"
import script from "./ComponentsTab.ts?vue&type=script&lang=ts&external"
export * from "./ComponentsTab.ts?vue&type=script&lang=ts&external"
import style0 from "./ComponentsTab.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports